'use es6';

const ThemeSingleton = {};
export function setTrellisThemeSingleton(theme) {
  if (theme) {
    ThemeSingleton.theme = theme;
  }
}
export function getTrellisThemeSingleton() {
  if (!ThemeSingleton.theme) {
    setTimeout(() => {
      throw new Error('Trellis theme not set');
    });
  }
  return ThemeSingleton.theme;
}